import { render, staticRenderFns } from "./FindUserOTP.vue?vue&type=template&id=5fc47968&scoped=true"
import script from "./FindUserOTP.vue?vue&type=script&lang=js"
export * from "./FindUserOTP.vue?vue&type=script&lang=js"
import style0 from "./FindUserOTP.vue?vue&type=style&index=0&id=5fc47968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc47968",
  null
  
)

export default component.exports